module.exports = __webpack_public_path__ + "img/img-5.28502ac1.png";